import { Parser } from "m3u8-parser";

/**
 * m3u8マスターマニフェストから画像ストリーム（サムネイル）のURIを抽出
 * #EXT-X-IMAGE-STREAM-INF タグのURI属性を取得
 * @see https://developers.play.jp/entry/2023/05/26/171431#EXT-X-IMAGE-STREAM-INF
 */
export const parseM3u8ToExtractThumbnailManifestFileName = (
  data: string
): string | null => {
  // m3u8-parserはEXT-X-IMAGE-STREAM-INFをサポートしていないため、正規表現で抽出
  const match = /#EXT-X-IMAGE-STREAM-INF:[^]*?URI="([^"]+)"/.exec(data);
  const uri = match?.[1] ?? null;
  if (uri === null) return null;

  // クエリパラメータを除去
  return uri.split("?")[0] ?? null;
};

const IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp"] as const;

const isImageUri = (uri: string): boolean => {
  return IMAGE_EXTENSIONS.some(
    (ext) => uri.endsWith(ext) || uri.includes(`${ext}?`)
  );
};

/**
 * m3u8プレイリストをパースして最後のサムネイルファイル名を取得
 */
export const parseM3u8ForLastThumbnail = (
  m3u8Content: string
): string | null => {
  const parser = new Parser();
  parser.push(m3u8Content);
  parser.end();

  const { segments } = parser.manifest;

  // 最後から逆順に探索して、画像ファイルのセグメントを見つける
  for (const { uri } of [...segments].reverse()) {
    if (!uri) continue;

    if (isImageUri(uri)) {
      // クエリパラメータを除いたファイル名を返す
      return uri.split("?")[0] ?? null;
    }
  }

  return null;
};
